import React, { useState } from "react";
import LoadingWithLable from "../../../../../../../../ReusableComponents/Loading/LoadingWithLable";
import { useOutletContext, useParams } from "react-router-dom";
import EditCandidate from "../../EditCandidate";
import CandidateExcelUpload from "../../CandidateExcelUpload";
import CandidateErrorPopUp from "../../CandidateErrorPopUp";
import ListDataUpdateFlightDetials from "./ListDataUpdateFlightDetails";

export default function UpdateFlightDetails() {
  const { projectId } = useParams();

  const outletContext = useOutletContext();
  const { candidateListData, setCandidateListData, loading } = outletContext;

  const [openCandidateUpload, setOpenCandidateUpload] = useState(false);
  const [showErrorPopUp, setShowErrorPopUp] = useState();

  return (
    <>
      {openCandidateUpload && (
        <CandidateExcelUpload
          showPromptElement={openCandidateUpload}
          setShowPromptElement={setOpenCandidateUpload}
          setShowErrorPopUp={setShowErrorPopUp}
          setCandidateListData={setCandidateListData}
          type="candidate_flight_details"
          title={"Upload Flight Details"}
        />
      )}
      {showErrorPopUp && (
        <CandidateErrorPopUp
          showErrorPopUp={showErrorPopUp}
          onToggle={() => setShowErrorPopUp(false)}
        />
      )}

      {loading ? (
        <LoadingWithLable />
      ) : (
        <ListDataUpdateFlightDetials
          setOpenCandidateUpload={setOpenCandidateUpload}
          candidateData={candidateListData}
          projectId={projectId}
          setCandidateListData={setCandidateListData}
        />
      )}
    </>
  );
}
